import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

export const GetUPSCcontent = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-upsc-content?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetGSSubjects = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-gs-subjects?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetGSSubjectChapters = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-gs-subject-chapters?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetGSSelectedChapter = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-selected-chapter-content?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetGSOverView = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-gs-overview?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};
export const GetPrelimsPYQ = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-prelims-pyq?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
      })}`
    )
  );
};

